<template>
  <svg
    class="surface"
    v-bind:class="{ flip }"
    width="71"
    height="72"
    viewBox="0 0 71 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M44.1638 27.4172L52.9966 18.5845C43.2402 8.82804 27.4219 8.82804 17.6655 18.5845L26.4983 27.4172C31.3765 22.539 39.2856 22.539 44.1638 27.4172Z"
      stroke="#778F9F"
      v-bind:class="{ selected: isSelected('oral_surface') }"
      v-bind:style="{ fill: partColor['oral_surface'] }"
      v-on:click="onClick('oral_surface', $event)"
      v-on:keydown="onClick('oral_surface', $event)" />
    <path
      d="M26.4983 45.0828L17.6655 53.9155C7.9091 44.1591 7.9091 28.3409 17.6655 18.5845L26.4983 27.4172C21.6201 32.2954 21.6201 40.2046 26.4983 45.0828Z"
      stroke="#778F9F"
      v-bind:class="{ selected: isSelected('distal_contact_surface') }"
      v-bind:style="{ fill: partColor['distal_contact_surface'] }"
      v-on:click="onClick('distal_contact_surface', $event)"
      v-on:keydown="onClick('distal_contact_surface', $event)" />
    <path
      d="M44.1638 27.4172L52.9966 18.5845C62.753 28.3409 62.753 44.1591 52.9966 53.9155L44.1638 45.0828C49.042 40.2046 49.042 32.2954 44.1638 27.4172Z"
      stroke="#778F9F"
      v-bind:class="{ selected: isSelected('medial_contact_surface') }"
      v-bind:style="{ fill: partColor['medial_contact_surface'] }"
      v-on:click="onClick('medial_contact_surface', $event)"
      v-on:keydown="onClick('medial_contact_surface', $event)" />
    <path
      d="M26.4983 45.0828L17.6655 53.9155C27.4219 63.672 43.2402 63.672 52.9966 53.9155L44.1638 45.0828C39.2856 49.961 31.3765 49.961 26.4983 45.0828Z"
      stroke="#778F9F"
      v-bind:class="{ selected: isSelected('vestibular_surface') }"
      v-bind:style="{ fill: partColor['vestibular_surface'] }"
      v-on:click="onClick('vestibular_surface', $event)"
      v-on:keydown="onClick('vestibular_surface', $event)" />
    <ellipse
      cx="35.2716"
      cy="36.2497"
      rx="12.4613"
      ry="12.3909"
      stroke="#778F9F"
      transform="rotate(180 35.2716 36.2497)"
      v-bind:class="{ selected: isSelected('central_surface') }"
      v-bind:style="{ fill: partColor['central_surface'] }"
      v-on:click="onClick('central_surface', $event)"
      v-on:keydown="onClick('central_surface', $event)" />
  </svg>
</template>

<script>
export default {
  computed: {
    partColor: ({ surface }) => Object.fromEntries(
      surface.map((part) => [part.id, (part.diagnoses[0] || {}).color || '#fff']),
    ),
  },
  methods: {
    isSelected(partId) {
      return this.partSelected === partId || this.selectedParts.includes(partId);
    },
    onClick(part, event) {
      this.$emit('select', part, event);
    },
  },
  props: {
    /**
     * @description Отразить по вертикали.
     * @type {boolean}
     */
    flip: { type: Boolean, default: false },
    /**
     * @description Выбранная часть.
     * @type {string}
     */
    partSelected: { type: String, default: '' },
    /**
     * @description Идентификаторы выбранных частей.
     * @type {string[]}
     */
    selectedParts: { default: () => [], type: Array },
    /**
     * @description Части поверхности зуба.
     * @type {any[]}
     */
    surface: { type: Array, required: true },
  },
};
</script>

<style scoped lang="scss">
.surface {
  pointer-events: none;
  position: relative;
  ellipse,
  path {
    pointer-events: all;
    &:hover,
    &.selected {
      stroke-width: 2px;
      stroke: var(--action-color);
    }
  }
  &.flip {
    transform: scaleX(-1);
  }
}
</style>
